import React from 'react';

var AddNew = React.createClass({
  getInitialState: function(){
    return {show: false, addNewData: []};
  },
  handleDropdownClick: function(e){
    e.stopPropagation();
    this.props.addNewDropdownShow();
  },
  handleAddNewClick: function(value){
    this.props.setAddNewValue(value);
  },
  render: function(){
    var addnew = this.props.addNewData;
    var result = addnew.map((value, index) => (
          <li onClick = {this.handleAddNewClick.bind(this,value)} key = {index}>
            <a href="javascript:void(0)">
              <span className="value">{value}</span>
            </a>
          </li>
    ));
    return(
          <div className="filter-head__left">
            <div className="custom-dropdown custom-dropdown--blue">
              <dl className="dropdown">
                <dt  onClick = {this.handleDropdownClick}>
                  <a href="javascript:void(0)">
                    <span className="value">{this.props.addNewValue}</span>
                  </a>
                </dt>
                <dd>
                { this.props.addNew ?
                  <ul>
                   {result}
                  </ul> : <div /> 
                }
                </dd>
              </dl>
            </div>
          </div> 
    );
  }

});

export {AddNew}


/** WEBPACK FOOTER **
 ** ./html/components/AddNew.jsx
 **/